// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"5b67272f","453":"0539a86e","508":"3ae26d72"}[chunkId] + ".chunk.js";
};